'use client';

/**
 * The chat icon on the navbar, left of the bell (docs/CHAT.md), as Reddit's:
 * a speech bubble with a red count of unread messages and waiting requests.
 * It opens and closes the chat window (ChatDock), and starts the page's one
 * live chat connection for the signed-in account.
 */

import { useEffect } from 'react';
import { useAuth } from '@/lib/auth';
import { startChat, toggleDock, useChat } from '@/lib/chat';
import { NAV_BTN } from '../nav/styles';
import ChatDock from './ChatDock';

export default function ChatButton() {
  const { loaded, user } = useAuth();
  useEffect(() => { if (loaded) startChat(user?.id ?? null); }, [loaded, user?.id]);
  const unread = useChat((s) => s.unread);
  const requests = useChat((s) => s.requests);
  const open = useChat((s) => s.dock.open);
  if (!loaded || !user) return null;
  const n = unread + requests;
  return (
    <>
      <button type="button" onClick={toggleDock} aria-expanded={open} aria-label={n ? `Chat, ${n} unread` : 'Chat'} title="Chat"
              className={'relative ' + NAV_BTN + (open ? ' bg-ink-100 text-ink-900 dark:bg-white/[0.08] dark:text-white' : '')}>
        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <path d="M12 3.5c4.7 0 8.5 3.3 8.5 7.4s-3.8 7.4-8.5 7.4c-.9 0-1.8-.1-2.6-.4L5 20l.9-3.6C4.4 15.1 3.5 13.1 3.5 10.9 3.5 6.8 7.3 3.5 12 3.5z" />
          <path d="M8.5 11h.01M12 11h.01M15.5 11h.01" strokeWidth="2.6" />
        </svg>
        {n > 0 && (
          <span className="absolute -right-0.5 -top-0.5 min-w-[18px] rounded-full bg-rose-500 px-1 text-center text-[10.5px] font-bold leading-[18px] text-white ring-2 ring-white dark:ring-ink-900">
            {n > 99 ? '99+' : n}
          </span>
        )}
      </button>
      <ChatDock />
    </>
  );
}
